import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

import colors from 'vuetify/lib/util/colors'

Vue.use(Vuetify)

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: colors.blueGrey.darken2,
        secondary: colors.lime.darken2,
        error: colors.red.darken4,
      },
    },
  },
})
